// removed by extract-text-webpack-plugin
module.exports = {"active":"active___1uQGe","navLink":"navLink___32eYI"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/Navigation/MegaNavLink.scss
// module id = lXgo
// module chunks = 60